<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('nav.partnersBtn')" />
    <partnersLogos />
    <featured />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import partnersLogos from "./../components/partnersLogos.vue";
import featured from "./../components/featured.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "Partners",
  components: {
    navMenu,
    hero,
    partnersLogos,
    featured,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
